<span class="inline-wrapper" [class.loading-shimmer]="showLoading()">
  <span #contentWrapper [class.opacity-0]="showLoading()">
    <ng-content></ng-content>
  </span>
  <!-- using childNodes here instead of children because children would just be empty if you only have text inside but no tags -->
  @if (!contentWrapper.childNodes.length) {
    &nbsp;
  }
</span>
